import { useContext, useEffect, useState } from "react"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { TextAtom } from "../atoms/TextAtom"
import { PageContext } from "../App"
import { TitleAtom } from "../atoms/titleAtom"
import { icon } from "../functions/icons"
import { getAPI, postAPI, updateAPI } from "../api/api"
import { Spinner } from "../atoms/spinner"
import { Search } from "../atoms/search"
import { StandardComp } from "../atoms/standardComp"
import { ToggleSwitch } from "../molecule/ToggleSwitch"
import { ModalButton, StandardButton } from "../atoms/buttons"

export const TapToLearnShareCampagne = ({ data, step }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [leads, setLeads] = useState([]);
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [selectLoader, setSelectLoading] = useState(false);
    const [sortType, setSortType] = useState("status");
    const [loading, setLoading] = useState(false);
    const navigationContext = useContext(PageContext);
    const [activeStepId, setActiveStepId] = useState(step)
    const [updatedLeads, setUpdatedLeads] = useState()
    const [showCampagneRelation, setShowCampagneRelation] = useState(false);
    const sortOptions = {
        newest: { title: "Nieuwste", icon: "arrow-down" },
        oldest: { title: "Oudste", icon: "arrow-up" },
        name: { title: "Naam A-Z", icon: "alphabet" },
        status: { title: "Actieve", icon: "status" },
        unselected: { title: "Niet gekoppeld", icon: "not-connected" },
    };

    const leadPicker = () => {
        const order = sortType === "oldest" ? "ASC" : "DESC";
        return data ? 
                    `api/campagne/campagne-card-leads/?search=${searchTerm}&id_campagne=${data}`
                    :
                    `api/cards/leads?search=${searchTerm}&sort=${sortType}&order=${order}&id_course=${navigationContext.sidebar.courseID}`;
                    
    };

    const leadPickerrr = async () => {
    return showCampagneRelation
        ? ( handleSaveButton(), getLinkedLeads() )
        : ( getLeads());
    };

    
    const getLeads = async () => {
        setLoading(true);
        const query = leadPicker();
        const res = await getAPI(query);
        console.log("res",res)
        if (res.status === "ok") {
        let list = res.data;
        const selected = list.filter(l => l.active).map(l => l.id_card);
        if (sortType === "unselected") {
            list = [
                ...list.filter(l => !l.active ? !l.active : !l.id_step), 
                ...list.filter(l => l.active ? l.active : l.id_step) 
            ];
        }

        setLeads(list);
        setSelectedLeads(selected);
        // console.log("SelectedLeads", selectedLeads)
        // setactiveStepId(res.data[0].id_step)
    }
        setLoading(false);
    };

        const getLinkedLeads = async () => {
        setLoading(true);
        const query = `api/campagne/campagne-cards`
        const res = await getAPI(query);
        console.log("res",res)
        if (res.status === "ok") {
        let list = res.data;
        const selected = list.filter(l => l.active).map(l => l.id_card);
        if (sortType === "unselected") {
            list = [
                ...list.filter(l => !l.active ? !l.active : !l.id_step), 
                ...list.filter(l => l.active ? l.active : l.id_step) 
            ];
        }

        setLeads(list);
        setSelectedLeads(selected);
        // console.log("SelectedLeads", selectedLeads)
        // setactiveStepId(res.data[0].id_step)
    }
        setLoading(false);
    };

    useEffect(() => {
        getLinkedLeads()
    }, [searchTerm, sortType]);

    const handleSortChange = () => {
        const keys = Object.keys(sortOptions);
        const currentIndex = keys.indexOf(sortType);
        const nextIndex = (currentIndex + 1) % keys.length;
        setSortType(keys[nextIndex]);
    };
 
    const handleSelectLead = (id_card) => {
            setSelectedLeads(prev => {
                const updated = prev.includes(id_card) ? prev.filter(id => id !== id_card) : [...prev, id_card]
                setLeads(l => l.map(lead => ({ ...lead, active: updated.includes(lead.id_card) })) );
                // const body = {
                //     id_cards: updated,
                //     ...(data ? { id_step: step } : { id_course: navigationContext.sidebar.courseID })
                // };                
                // console.log("bwwody:", body);
                // postAPI(data ? "api/campagne/add-step" : "api/cards/add-course", body);
                setUpdatedLeads(updated)
                return updated;
            });
    };

    const handleSaveButton = async () => {
                const body = {
                    id_cards: updatedLeads,
                    ...(data ? { id_step: step } : { id_course: navigationContext.sidebar.courseID })
                };                
                console.log("bwwody:", body);
                await postAPI(data ? "api/campagne/add-step" : "api/cards/add-course", body);
    }


    const toggleAll = async () => {
        setSelectLoading(true);
        const allSelected = selectedLeads.length === leads.length;
        const updated = allSelected ? [] : leads.map(l => l.id_card);
        setSelectedLeads(updated);
        setLeads(l => l.map(lead => ({ ...lead, active: updated.includes(lead.id_card) })));
        await 
            data ? 
                postAPI("api/campagne/add-step", {id_step: step, id_cards: updated})

            :        
                postAPI("api/cards/add-course", {id_course: navigationContext.sidebar.courseID,id_cards: updated})

        
        setSelectLoading(false);
    };

    const selectedCount = selectedLeads.length;
    const allSelected = leads.length > 0 && selectedCount === leads.length;
    console.log("leads",leads)
    return (
        <VerticalLayout>
            <TitleAtom className={"standard-margin"} title={"Tap to Learn"} />
            {/* <SearchAndFilter searchTerm={searchTerm}  setSearchTerm={setSearchTerm} sortType={sortType} sortOptions={sortOptions} onSortChange={handleSortChange} onChange={toggleAll} checked={allSelected}/> */}
            {/* {loading ? <VerticalLayout className="center"><Spinner /></VerticalLayout> : <LeadCardList selectedLeads={selectedLeads} onSelectLead={handleSelectLead} leads={leads} /> } */}
            {/* {loading ? <VerticalLayout className="center"><Spinner /></VerticalLayout> : {showCampagneRelation ? <CampagneCardRelation selectedLeads={selectedLeads} onSelectLead={handleSelectLead} leads={leads} /> : LeadCardList selectedLeads={selectedLeads} leads={leads} />}< } */}
            {loading ? (
                    <VerticalLayout className="center">
                    <Spinner />
                    </VerticalLayout>
                    ) : (
                    showCampagneRelation ? (
                        <>
                    <SearchAndFilter searchTerm={searchTerm}  setSearchTerm={setSearchTerm} sortType={sortType} sortOptions={sortOptions} onSortChange={handleSortChange} onChange={toggleAll} checked={allSelected}/>
                    <CampagneCardRelation
                        selectedLeads={selectedLeads}
                        onSelectLead={handleSelectLead}
                        leads={leads}
                        showCampagneRelation={showCampagneRelation}
                    />
                    </>
                    ) : (
                    <LeadCardList
                        selectedLeads={selectedLeads}
                        leads={leads}
                    />
                    )
                    )
                }
                    <ModalButton
                    onClick={() => {leadPickerrr(); setShowCampagneRelation(prev => !prev);}}                    
                    title={showCampagneRelation ? "Opslaan" : "Lead koppelen"}
                    style={{ margin: "auto 1rem 1rem 1rem", marginTop: "0.75rem" }}
                    />
        </VerticalLayout>   
    )
}
 

    const CampagneCardRelation = ({ leads, selectedLeads, onSelectLead, showCampagneRelation  }) => {

        return (
            <VerticalLayout style={{ width: "auto", gap: "1rem", maxHeight: "400px", overflowY: "auto", paddingRight: "0.5rem" }} className="standard-margin">
                {leads.map(lead => (
                    <LeadCard isSelected={selectedLeads.includes(lead.id_card)} key={lead.id_card} lead={lead} onSelectLead={onSelectLead} showCampagneRelation={showCampagneRelation} />
                ))}
            </VerticalLayout>
        )
    }

const LeadCardList = ({ leads, selectedLeads, onSelectLead  }) => {

    return (
        <VerticalLayout style={{ width: "auto", gap: "1rem", maxHeight: "400px", overflowY: "auto", paddingRight: "0.5rem" }} className="standard-margin">
            {leads.map(lead => (
                <LeadCard key={lead.id_card} lead={lead}  />
            ))}
        </VerticalLayout>
    )
}

const LeadCard = ({ lead, isSelected, onSelectLead, showCampagneRelation  }) => {
    const getStatusColor = (status) => {
        switch (status) {
            case 0:
                return "var(--grey-400)"; 
            case 1:
                return "var(--success-600)"; 
            default:
                return "var(--grey-400)";
        }
    };

    return (
        <StandardComp
            onClick={() => {showCampagneRelation && onSelectLead(lead.id_card)}}
            style={{ padding:"1rem", width: "auto"}}
            editClass={`no-margin lead-cards ${isSelected ? "selected" : ""}`}
            content={
                <>
                <HorizontalLayout className="space-between lead-name-container" style={{ width: "unset", alignItems: "center" }}>
                    {icon("status", 15,getStatusColor(lead.status))}
                    {isSelected && icon("check", 15, "var(--primary-600)")}
                </HorizontalLayout>
                <TextAtom className="lead-name" title={lead.first_name || lead.last_name ? `${lead.first_name || ""} ${lead.last_name || ""}`.trim() : !lead.email && "Kaart niet gekoppelt" } />
                <TextAtom className={"lead-email"} title={lead.email} />
                {lead.company_name && <TextAtom className={"lead-company"} title={lead.company_name} />}
                </>
        } />
    )
}
const SearchAndFilter = ({ searchTerm, setSearchTerm, sortType, sortOptions, onSortChange, onChange, checked }) => {
    const currentSort = sortOptions[sortType];
    return (
        <HorizontalLayout style={{ margin: "1rem 1rem 1rem .25rem", width: "auto" }}>
            <Search
                className="tap-to-learn-search"
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Zoek lead"
            />
            <StandardButton
                onClick={onSortChange}
                backgroundColor="transparent"
                textColor="primary-600"
                className="sort-icon"
                style={{
                    minWidth: "10rem",
                    border: "1px solid var(--grey-400)",
                    marginRight: ".5rem",
                    padding: ".75rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem",
                }}
                title={currentSort.title}
            >
                {icon(currentSort.icon, 17, currentSort.icon === "status" ? "var(--success-600)" : "var(--primary-600)")}
            </StandardButton>
               <ToggleSwitch
                    // leftTitle={checked ? "Deselecteer alles" : "Selecteer alles"}
                    className={`department-switch ${checked ? "active" : ""}`}
                    checked={checked}
                    onChange={onChange}
                />
        </HorizontalLayout>
    );
};